import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { palette } from '@shared/tokens/palette.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  modal: {
    minHeight: '704px',
  },
  modalHeader: {
    fontSize: typography['fontSizeBody-1'],
    lineHeight: typography['lineHeightBody-1'],
    padding: `${anatomy['space-24']} ${anatomy['space-32']}`,
    ':not(#__unused__) > button': {
      top: anatomy['space-20'],
      right: anatomy['space-32'],
    },
  },
  container: {
    padding: `0 ${anatomy['space-32']}`,
    display: 'flex',
    gap: anatomy['space-24'],
    color: colors.primaryText,
    flexGrow: 1,
  },
  actions: {
    display: 'flex',
    gap: anatomy['space-12'],
  },
  participants: {
    flexGrow: 1,
    maxHeight: '540px',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'auto',
    '::-webkit-scrollbar': {
      width: '6px',
      backgroundColor: palette['grey-50'],
    },
    '::-webkit-scrollbar-thumb': {
      width: anatomy['size-4'],
      backgroundColor: colors.accentBackground,
      borderRadius: anatomy['size-8'],
      border: '1px solid #f9f9f9',
    },
  },
  participant: {
    padding: '8px 12px',
    display: 'flex',
    gap: anatomy['space-8'],
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    alignItems: 'center',
    ':not(#__unused__) > input': {
      padding: anatomy['space-4'],
      alignSelf: 'flex-start',
    },
  },
  checkAllButton: {
    ':not(#__unused__) input::before': {
      backgroundImage:
        "url(\"data:image/svg+xml,%3Csvg width='10' height='2' viewBox='0 0 10 2' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1H9' stroke='white' stroke-opacity='1' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\") !important",
      backgroundColor: colors.accentBackground,
    },
  },
  editButton: {
    color: palette['grey-500'],
    marginLeft: 'auto',
    ':hover': {
      color: colors.accentIcon,
    },
  },
  notFound: {
    flexGrow: 1,
    display: 'block',
    textAlign: 'center',
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    color: palette['grey-500'],
  },
  loader: {
    margin: '0 auto',
  },
  counter: {
    marginLeft: 'auto',
    color: palette['grey-700'],
  },
  modalStatusHeader: {
    fontSize: typography['fontSizeBody-1'],
    lineHeight: typography['lineHeightBody-1'],
    padding: `${anatomy['space-16']} ${anatomy['space-24']}`,
    ':not(#__unused__) > button': {
      top: anatomy['space-20'],
      right: anatomy['space-24'],
    },
  },
  modalStatus: {
    ':not(#__unused__) > div:last-child': {
      padding: `${anatomy['space-16']} ${anatomy['space-24']}`,
      ':not(#__unused__) button': {
        fontSize: typography['fontSizeCaption-1'],
        height: anatomy['size-36'],
      },
    },
  },
  modalStatusContent: {
    fontSize: typography['fontSizeCaption-1'],
    color: 'rgba(43, 52, 60, 0.6)',
    padding: `0 ${anatomy['space-24']}`,
    display: 'flex',
    gap: anatomy['space-16'],
    alignItems: 'center',
  },
  icon: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
});
